export default {"src":"/_next/static/media/arrows_in.b4ecf096.svg","height":395,"width":251,"blurWidth":0,"blurHeight":0};